var _defs, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkyline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 289 145",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 239.7,
    x2: 239.7,
    y1: 143.8,
    y2: 288.5,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-95 -144)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 239.7,
    x2: 239.7,
    y1: 143.8,
    y2: 288.5,
    gradientTransform: "matrix(1 0 0 1.00046 -95 -144)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 174.7,
    cy: 437.1,
    r: 144.7,
    gradientTransform: "matrix(.07245 .6878 -1.442 .1519 673 -166)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 229.5,
    cy: -99.1,
    r: 144.7,
    gradientTransform: "matrix(-.97196 .5574 -.5733 -.99967 407 -205)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M0 0h289v145H0z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "lighten"
    },
    fill: "url(#b)",
    d: "M0 0h289v145H0z",
    opacity: 0.6
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    fillOpacity: 0.3,
    d: "M0 0h289v145H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M0 144v-30h1v-9h1v-1h2v10h2v-8h2v-8h1v-1h2v1h2v12h4v4h3v-9h1v-1h1v-1h2v1h1v10h5v-2h1v-8h3l1-1h3v5h2v-4h2v-1h3v1h1v2h1v5h1v3h3v-2h2V93h1v-1h5v18h4v-4h2v-8l1-2h4l1 1h1v7h1v4h3V85l4-5v3h4v15h3v-5l1-2h4v17h2v6h4v-3h2v-1h2v-9l3-2h4v2h3v13l3-3v-3h1v-6h1v-1h2v1h2v1l2 2v2l2 2h4v-2h1v-1h2v3h2v-7h2v-1h2v1h1v12l2-3h2v-2h1V99h1v-2h1v-3h2v2h1v3h1v2h1v9l4 4h2V83l6-6v27h3v10h4v-8h1v-1h3v-2h2v-1h2l3 2h1v10h3v-8h1v-1h2v1h2v5l1-2v-8h2l2 1v4l1 2v6h3v-14h3v6h2v2l1 2h2l1-1v-3h2v2l3 2v2h4v-6h3v-3h5v6h2v-2l1-1h3l1-1h2v6h3v-5h2v-2h3v7h3v-11h3v6h3l1 1v6h2v-11h3v6h2v6h6V97h2v-1h1v1h1v8h3v-2l1-1h2v10h1v-2l1-1h2v-9l1-1h3v15h3v-8h3v39L0 144z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "darken"
    },
    fill: "#b3b3b3",
    d: "M0 144v-30h1v-9h1v-1h2v10h2v-8h2v-8h1v-1h2v1h2v12h4v4h3v-9h1v-1h1v-1h2v1h1v10h5v-2h1v-8h3l1-1h3v5h2v-4h2v-1h3v1h1v2h1v5h1v3h3v-2h2V93h1v-1h5v18h4v-4h2v-8l1-2h4l1 1h1v7h1v4h3V85l4-5v3h4v15h3v-5l1-2h4v17h2v6h4v-3h2v-1h2v-9l3-2h4v2h3v13l3-3v-3h1v-6h1v-1h2v1h2v1l2 2v2l2 2h4v-2h1v-1h2v3h2v-7h2v-1h2v1h1v12l2-3h2v-2h1V99h1v-2h1v-3h2v2h1v3h1v2h1v9l4 4h2V83l6-6v27h3v10h4v-8h1v-1h3v-2h2v-1h2l3 2h1v10h3v-8h1v-1h2v1h2v5l1-2v-8h2l2 1v4l1 2v6h3v-14h3v6h2v2l1 2h2l1-1v-3h2v2l3 2v2h4v-6h3v-3h5v6h2v-2l1-1h3l1-1h2v6h3v-5h2v-2h3v7h3v-11h3v6h3l1 1v6h2v-11h3v6h2v6h6V97h2v-1h1v1h1v8h3v-2l1-1h2v10h1v-2l1-1h2v-9l1-1h3v15h3v-8h3v39L0 144z"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    fillOpacity: 0.3,
    d: "M0 0h289v145H0z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "lighten"
    },
    fill: "url(#e)",
    d: "M0 0h289v145H0z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkyline);
export default __webpack_public_path__ + "static/media/skyline.ece5a5fafa1215c059091dcd36644c6b.svg";
export { ForwardRef as ReactComponent };